import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useGetUserQuery, useModifyUserMutation } from '../../services/usersApi';

export default function ProfileManagementPage() {
    const toast = useRef(null);
    const { data: user, isLoading } = useGetUserQuery();
    const [modifyUser, { isLoading: updating }] = useModifyUserMutation();

    const [formData, setFormData] = useState({
        username: '',
        name: '',
        newPassword: '',
        confirmPassword: ''
    });

    useEffect(() => {
        if (user) {
            setFormData({
                username: user.username || '',
                name: user.name || '',
                newPassword: '',
                confirmPassword: ''
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { username, name, newPassword, confirmPassword } = formData;

        if (newPassword && newPassword !== confirmPassword) {
            toast.current.show({ severity: 'error', summary: 'Błąd', detail: 'Hasła nie są identyczne', life: 3000 });
            return;
        }

        try {
            const payload = { _id: user._id, username, name };
            if (newPassword) payload.password = newPassword;

            await modifyUser(payload).unwrap();
            toast.current.show({ severity: 'success', summary: 'Sukces', detail: 'Profil zaktualizowany', life: 3000 });
            setFormData(prev => ({ ...prev, newPassword: '', confirmPassword: '' }));
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Błąd', detail: err.data?.message || 'Coś poszło nie tak', life: 3000 });
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }

    if (isLoading) {
        return (
            <div className="p-4 flex justify-content-center">
                <ProgressSpinner />
            </div>
        );
    }

    return (
        <div className="p-4 flex justify-content-center">
            <Card title="Mój profil" style={{ width: '400px' }} className="p-shadow-3">
                <Toast ref={toast} />
                <form onSubmit={handleSubmit} className="p-fluid">
                    <div className="p-field mb-2">
                        <label htmlFor="username">Nazwa użytkownika</label>
                        <InputText id="username" name="username" value={formData.username} onChange={handleChange} />
                    </div>

                    <div className="p-field mb-2">
                        <label htmlFor="name">Imię i nazwisko</label>
                        <InputText id="name" name="name" value={formData.name} onChange={handleChange} />
                    </div>

                    <div className="p-field mb-2">
                        <label htmlFor="newPassword">Nowe hasło</label>
                        <Password id="newPassword" name="newPassword" value={formData.newPassword} feedback={false} onChange={handleChange} toggleMask />
                    </div>

                    <div className="p-field ">
                        <label htmlFor="confirmPassword">Potwierdź hasło</label>
                        <Password id="confirmPassword" name="confirmPassword" value={formData.confirmPassword} feedback={false} onChange={handleChange} toggleMask />
                    </div>

                    <div className=" flex-col justify-content-center mt-4">
                        <Button className="p-button-success mb-2" type="submit" label="Zapisz zmiany" icon="pi pi-save" loading={updating} />
                        <Button className="p-button-secondary " type="button" severity="danger" label="Wylogowanie" icon="pi pi-times" onClick={logout} />
                    </div>
                </form>
            </Card>
        </div>
    );
}
